const Search = ({ query, setQuery, placeholder, width, height, iconSize, style }) => {
  return (
    <div
      style={{
        width: width,
        height: height,
        backgroundColor: 'var(--studio-search-bar)',
        borderRadius: '2px',
        padding: '10px 20px 10px 20px',
        display: 'flex',
        alignItems: 'center',
        ...style
      }}
    >
      <img src="/static/icons/studio_search.svg" style={{ height: iconSize, width: iconSize }} />
      <input
        value={query}
        placeholder={placeholder}
        onChange={(e) => {
          const value = e.target.value
          setQuery(value)
        }}
        className="input-clear"
        style={{
          color: 'white',
          padding: '0 0 0 0',
          marginLeft: '10px',
          marginRight: '10px',
          width: '100%'
        }}
      />
      {query && (
        <img
          onClick={() => setQuery('')}
          className="cursor-pointer"
          src="/static/icons/close_white_24dp.svg"
          style={{ height: iconSize, width: iconSize }}
        />
      )}
    </div>
  )
}

Search.defaultProps = {
  query: '',
  placeholder: '',
  setQuery: () => {},
  style: {},
  width: '100%',
  height: '32px',
  iconSize: '16px'
}

export default Search
